<template>
  <div class="row">
    <div class="col-12 px-3">
      <div class="dashboard-rh">
        <div class="row px-1">
          <div class="item bg-gradient-info col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Total de horas alocadas
              <b-badge variant="light">Planejado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalHorasPrevisto }} Hrs
            </h4>
          </div>
          <div class="item bg-gradient-info col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Valor total <b-badge variant="light">Planejado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalValorPrevisto }}
            </h4>
          </div>
          <div class="item bg-gradient-success col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Total de horas alocadas
              <b-badge variant="light">Realizado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalHorasRealizado }} Hrs
            </h4>
          </div>
          <div class="item bg-gradient-success col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Valor total <b-badge variant="light">Realizado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalValorRealizado }}
            </h4>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      title="Filtro declaração HH"
      id="modalHH"
      ok-variant="success"
      ok-title="Gerar declaração"
      cancel-title="Fechar"
      @ok="gerarDeclaracao"
    >
      <modal-h-h
        :projeto-id="projetoId"
        :nome-id-projeto="nomeIdProjeto"
        :projeto="projeto"
        ref="modalDeclaracao"
      />
    </b-modal>
    <select-modal
      id="RH"
      placeholder-button="Inserir"
      titleModal="INSERIR PESSOA"
      :modal-fields="colunasModal"
      :fetch-method="metodoBusca"
      term-initial="nome"
      slot-image="foto"
      :values="realizado"
      hide-button
      class-button="px-3 py-3"
      class="col-12"
      :btn-inserir="permissaoPessoa.c"
      btn-tipo="pessoas"
      @update="adicionarPessoa"
      :controles="true"
      ref="selectModal"
    >
      <template #before-table>
        <accordion :id="`rh-1`" title="Planejado" sub accordion="rh-1" visible>
          <div class="p-3">
            <tabela
              realizada
              :duracao="projeto.duracao"
              :itens="proposta"
              :projeto="projeto"
            />
          </div>
        </accordion>
      </template>
      <template #table>
        <accordion :id="`rh-2`" title="Realizado" sub accordion="rh-2" visible>
          <template #append-title>
            <div class="d-flex">
              <b-button
                variant="info"
                v-if="permissaoRH.c && projetoEditavel"
                size="sm"
                class="ml-2"
                @click="clicado"
                >Adicionar pessoa</b-button
              >
              <b-button
                variant="success"
                size="sm"
                class="ml-2"
                @click="baixarRelatorioHH"
              >
                <i class="fas fa-cloud-download mr-2"></i>
                Declaração HH
              </b-button>
            </div>
          </template>
          <div class="p-3">
            <tabela
              realizada
              :esconder-editar="!permissaoRH.u"
              :esconder-excluir="!permissaoRH.d"
              :duracao="projeto.duracao"
              :projeto="projeto"
              :itens="realizado"
              :controles="projetoEditavel"
              @atualizar="salvarPessoa"
              @deletar="deletarPessoa"
              @baixarHH="baixarRelatorioHHPessoa"
              ref="tabela"
            />
          </div>
        </accordion>
        <accordion
          :id="`rh-3`"
          title="Atribuir alocação por empresa"
          sub
          accordion="rh-3"
          v-if="exibirAlocacao"
        >
          <template #append-title>
            <div class="ml-2">
              <b-badge
                v-if="calculoAlocacao < 90"
                variant="danger"
                class="py-1"
              >
                Sem alocação
              </b-badge>
              <b-badge v-else variant="success" class="py-1 my-auto">
                {{ parseFloat(calculoAlocacao.toFixed(2)) }} % alocado
              </b-badge>
            </div>
          </template>
          <div class="p-3">
            <div class="d-flex mb-3">
              <b-progress class="flex-fill mr-2" height="35px" :max="100">
                <b-progress-bar
                  :id="`tooltip_${i}`"
                  :variant="retornarVariante(i)"
                  :value="alocacao.porcentagem"
                  v-for="(alocacao, i) in alocacoes"
                  :key="`alocacao${i}`"
                  >{{ alocacao.empresaInvestidora }} -
                  {{ alocacao.porcentagem }}%</b-progress-bar
                >
                <b-tooltip
                  v-for="(alocacao, i) in alocacoes"
                  :key="`alocacao-tooltip${i}`"
                  :target="`tooltip_${i}`"
                  >{{ alocacao.empresaInvestidora }} -
                  {{ alocacao.porcentagem }}%</b-tooltip
                >
              </b-progress>
              <b-button
                v-if="permissaoRH.u && projetoEditavel"
                size="sm"
                @click="$bvModal.show('bv-modal-alocacao')"
              >
                <i class="fas fa-edit mr-2"></i>
                Editar alocações
              </b-button>
              <b-modal
                size="xl"
                title="Alocações"
                :ok-variant="permissaoRH.u ? 'success' : 'secondary'"
                :ok-title="permissaoRH.u ? 'Salvar' : 'Fechar'"
                :ok-only="!permissaoRH.u"
                cancel-title="Fechar"
                id="bv-modal-alocacao"
                @ok="salvarAlocacao"
              >
                <div
                  class="row"
                  v-for="(alocacao, i) in alocacoesModal"
                  :key="`input-alocacao-${i}`"
                >
                  <input-text
                    ref="alocacao"
                    class="col-12"
                    :min="0"
                    :max="100"
                    v-model="alocacao.porcentagem"
                    type="number"
                    :label="`Porcentagem paga empresa investidora (${alocacao.empresaInvestidora})`"
                  >
                    <template #label>
                      <div>
                        Porcentagem da empresa {{ alocacao.empresaInvestidora }}
                        <b-badge class="ml-2" variant="info">{{
                          calcularValor(alocacao.porcentagem)
                        }}</b-badge>
                      </div>
                    </template>
                  </input-text>
                </div>
              </b-modal>
            </div>
            <hr />
            <div
              class="d-flex justify-content-between"
              v-for="(alocacao, i) in alocacoes"
              :key="`valores_alocados${i}`"
            >
              <div class="d-flex mb-2" style="width: 80%">
                <div>{{ alocacao.empresaInvestidora }}</div>
                <b-progress class="flex-fill ml-2" height="20px" :max="100">
                  <b-progress-bar
                    :variant="retornarVariante(i)"
                    :value="alocacao.porcentagem"
                    >{{ alocacao.porcentagem }}%</b-progress-bar
                  >
                </b-progress>
              </div>
              <div class="h6">
                {{ calcularValor(alocacao.porcentagem) }}
              </div>
            </div>
          </div>
        </accordion>
        <accordion
          :id="`rh-4`"
          title="ARMAZENAR DECLARAÇÃO DE RH"
          sub
          accordion="rh-4"
        >
          <div>
            <formulario-h-h
              :projeto-id="projetoId"
              :nome-id-projeto="nomeIdProjeto"
              :projeto="projeto"
              ref="comprovantehh"
              :equipe-id="equipeId"
              :projeto-editavel="projetoEditavel"
            />
          </div>
        </accordion>
      </template>
    </select-modal>
  </div>
</template>
<script>
import SelectModal from "@/components/modal/SelectModal.vue";
import Accordion from "@/components/card/Accordion.vue";
import ProjetoService from "@/common/services/projeto/projeto.service";
import PessoaService from "@/common/services/pessoa/pessoa.service";
import Tabela from "./componentes/Tabela";
import FormularioHH from "./componentes/FormularioHH";

import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import { FormMixin } from "@/common/mixins/FormMixin";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";

import InputText from "@/components/inputs/InputText.vue";

import ModalHH from "./componentes/ModalHH.vue";

export default {
  mixins: [AlertasMixin, FormMixin],
  props: {
    endpointProposta: {
      type: String,
      required: true,
    },
    projetoId: {
      type: String,
      required: true,
    },
    projetoIdBase: {
      type: String,
      required: true,
    },
    nomeIdProjeto: {
      type: String,
      required: true,
    },
    projeto: {
      required: true,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectModal,
    Tabela,
    Accordion,
    InputText,
    FormularioHH,
    ModalHH,
  },
  data: () => ({
    colunasModal: [
      { key: "acoes", label: "Ações", tdClass: "acoes" },
      { key: "foto", label: "" },
      { key: "nome", label: "Nome" },
      { key: "email", label: "E-mail" },
      { key: "endereco.cidade", label: "Cidade" },
      { key: "titulacao", label: "Titulação" },
    ],
    realizado: [],
    proposta: [],

    alocacoes: [],
    alocacoesModal: [],

    equipeId: null,

    options: {
      variants: [
        { id: "primary", text: "primary" },
        { id: "success", text: "success" },
        { id: "danger", text: "danger" },
        { id: "warning", text: "warning" },
        { id: "info", text: "info" },
      ],
    },
  }),
  methods: {
    clicado: function (e) {
      e.stopPropagation();
      this.$refs.selectModal.openModal();
    },

    retornarVariante: function (i) {
      let n = i + "";
      let ultima = n.substr(n.length - 1);

      if (ultima > 4) {
        ultima -= 5;
      }

      return this.options.variants[ultima].id;
    },

    metodoBusca: function () {
      return PessoaService.listar(this.selectedCompany.id);
    },

    adicionarPessoa: function (item) {
      let form = {
        pessoaId: item.item.id,
      };
      form[this.nomeIdProjeto] = this.projetoId;

      this.$store.dispatch(START_LOADING);
      ProjetoService.adicionarRH(form)
        .then(() => {
          this.toast("Pessoa adicionada com sucesso!", { variant: "success" });
          this.buscarRealizado();
        })
        .catch(() => {
          this.toast("Erro ao adicionar pessoa!", { variant: "error" });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    salvarPessoa: function (item) {
      if (!this.$refs.tabela.validarFormulario(`tabela-${item.id}`)) return;

      let form = cloneDeep(item);
      form[this.nomeIdProjeto] = this.projetoId;
      form.alocacaoHoraIndividualId = item.id;
      form.valorHora = helpers.removerValor(item.valorHora);

      this.confirmar("Aviso", "Tem certeza que deseja alterar os dados?").then(
        (confirmado) => {
          if (!confirmado) return;

          this.$store.dispatch(START_LOADING);
          ProjetoService.salvarRH(form)
            .then(() => {
              this.toast("Pessoa salva com sucesso!", { variant: "success" });
              this.buscarRealizado();
            })
            .catch((err) => {
              if (!err.response)
                this.toast("Erro ao salvar pessoa!", { variant: "error" });

              this.alertaErro(err.response.data.errors);
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      );
    },

    deletarPessoa: function (item) {
      let form = {
        alocacaoHoraIndividualId: item.id,
      };
      form[this.nomeIdProjeto] = this.projetoId;

      this.confirmar(
        "Aviso",
        "Tem certeza que deseja excluir esta pessoa?"
      ).then((confirmado) => {
        if (!confirmado) return;

        this.$store.dispatch(START_LOADING);

        ProjetoService.deletarRH(form)
          .then(() => {
            this.toast("Pessoa excluida com sucesso!", { variant: "success" });
            this.buscarRealizado();
          })
          .catch(() => {
            this.toast("Erro ao excluir pessoa!", { variant: "error" });
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    buscarRealizado: function () {
      this.$store.dispatch(START_LOADING);
      ProjetoService.listarRH(this.projetoId, this.nomeIdProjeto)
        .then((res) => {
          this.equipeId = res.data.data.id;
          this.$refs.comprovantehh.montar(this.equipeId);
          this.realizado = res.data.data
            ? res.data.data.equipe.alocacaoHorasIndividuais
            : [];
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    buscarProposta: function () {
      ProjetoService.buscarRubricaProposta(
        this.endpointProposta,
        "recurso-humano",
        this.projetoId
      ).then((response) => {
        let dados = response.data.data;
        let equipe = dados ? dados.equipe : null;
        this.proposta = equipe ? equipe.alocacaoHorasIndividuais : [];
      });
    },

    montar() {
      this.buscarRealizado();
      this.buscarProposta();
      this.buscarAlocacao();
    },

    buscarAlocacao: function () {
      ProjetoService.retornaAlocacao(this.projetoId, this.nomeId).then(
        (res) => {
          this.alocacoesModal = cloneDeep(res.data.data);
          this.alocacoes = res.data.data;
        }
      );
    },

    calcularValor: function (porcentagem) {
      return helpers.formatarValor(
        (helpers.removerValor(this.totalValorRealizado) * porcentagem) / 100
      );
    },

    salvarAlocacao: function (e) {
      e.preventDefault();
      this.confirmar("Deseja alterar as porcentagens de alocações?").then(
        (confirmado) => {
          if (!confirmado) return;

          if (!this.validateState("alocacao")) return;

          this.$store.dispatch(START_LOADING);
          ProjetoService.salvarAlocacao(this.alocacoesModal)
            .then(() => {
              this.alertaSucesso("Alocações salvas com sucesso!");
              this.buscarAlocacao();
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else {
                this.alertaErro("Erro ao salvar alocações!");
              }
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      );
    },

    gerarDeclaracao: function (e) {
      e.preventDefault();

      let form = this.$refs.modalDeclaracao.getForm();

      this.$store.dispatch(START_LOADING);
      ProjetoService.baixarHH(this.projetoId, form.pessoaId, form.data)
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Relatório HH.pdf`;
          link.click();
        })
        .catch(() => {
          this.toast("Erro ao gerar declaração de HH!", { variant: "error" });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    baixarRelatorioHH: function (e) {
      e.stopPropagation();

      this.$bvModal.show("modalHH");
    },

    baixarRelatorioHHPessoa: function (idPessoa) {
      this.$store.dispatch(START_LOADING);
      ProjetoService.baixarHH(this.projetoId, idPessoa)
        .then((res) => {
          this.$store.dispatch(STOP_LOADING);
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Relatório Individual HH.pdf`;
          link.click();
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  computed: {
    nomeId: function () {
      switch (this.$route.name) {
        case "projeto-detalhamento":
          return "projetoId";
        default:
          return "projetoCooperadaId";
      }
    },
    permissaoRH() {
      return this.$store.getters["app/retornaPermissao"](
        "ProjetosPdRecursoHumano"
      );
    },
    permissaoPessoa() {
      return this.$store.getters["app/retornaPermissao"]("Pessoas");
    },

    selectedCompany() {
      return this.$store.state.app.selectedCompanyObj;
    },

    horasSazonaisRealizado: function () {
      let horas = [];
      for (let index = 0; index <= this.projeto.duracao; index++) {
        let quantidade = 0;
        this.realizado.forEach((element) => {
          quantidade += element.horasSazonais.find((el) => el.mes == index)
            ? element.horasSazonais.find((el) => el.mes == index).horas
            : 0;
        });
        horas.push({
          mes: index,
          horas: quantidade,
        });
      }
      return horas;
    },
    horasSazonaisPrevisto: function () {
      let horas = [];
      for (let index = 0; index <= this.projeto.duracao; index++) {
        let quantidade = 0;
        this.proposta.forEach((element) => {
          quantidade += element.horasSazonais.find((el) => el.mes == index)
            ? element.horasSazonais.find((el) => el.mes == index).horas
            : 0;
        });
        horas.push({
          mes: index,
          horas: quantidade,
        });
      }
      return horas;
    },
    valorPessoaRealizado: function () {
      return this.realizado.reduce(
        (total, pessoa) =>
          total + (pessoa.valorHora ? parseInt(pessoa.valorHora) : 0),
        0
      );
    },
    valorPessoaPrevisto: function () {
      return this.proposta.reduce(
        (total, pessoa) =>
          total + (pessoa.valorHora ? parseInt(pessoa.valorHora) : 0),
        0
      );
    },

    totalHorasRealizado: function () {
      return this.horasSazonaisRealizado.reduce(
        (total, hora) => total + parseInt(hora.horas),
        0
      );
    },
    totalHorasPrevisto: function () {
      return this.horasSazonaisPrevisto.reduce(
        (total, hora) => total + parseInt(hora.horas),
        0
      );
    },

    totalValorRealizado: function () {
      return helpers.formatarValor(
        this.realizado.reduce((total, pessoa) => {
          return (
            total +
            pessoa.horasSazonais.reduce(
              (total, hora) => total + parseInt(hora.horas),
              0
            ) *
              pessoa.valorHora
          );
        }, 0)
      );
    },
    totalValorPrevisto: function () {
      return helpers.formatarValor(
        this.proposta.reduce((total, pessoa) => {
          return (
            total +
            pessoa.horasSazonais.reduce(
              (total, hora) => total + parseInt(hora.horas),
              0
            ) *
              pessoa.valorHora
          );
        }, 0)
      );
    },
    calculoAlocacao: function () {
      if (!this.alocacoes) return false;

      if (this.alocacoes.length == 0) return false;
      const teste = this.alocacoes.reduce(
        (total, alocacao) => total + alocacao.porcentagem,
        0
      );
      return teste;
    },
    exibirAlocacao: function () {
      return (
        this.$route.name == "projeto-detalhamento-executora-criadora" ||
        this.$route.name == "projeto-detalhamento-executora-associada"
      );
    },
  },
  mounted() {},
};
</script>
<style></style>
